export default __webpack_public_path__ + "static/media/Arm-bands of the Hell Walker.4b83116a.jpg";